import { memo } from 'react';

import { styled } from 'styled-components';

const StyledLi = styled.li`
  &.custom-right-arrow {
    position: relative;
  }
  &.custom-right-arrow::after {
    content: '>';
    display: flex;
    height: 22px;
    width: 18px;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }
`;

const Nav = (props) => {
  const { navList, showLastArrow = true } = props;
  const len = navList?.length || 0;

  return (
    <nav role={'navigation'} className={'text-[14px]'} aria-label="面包屑导航">
      <ol className={'flex items-center'}>
        {navList.map((item, index) => {
          return (
            <StyledLi
              key={index}
              className={`${item.url ? 'cursor-pointer' : 'cursor-default'} flex h-[22px] items-center justify-center ${(showLastArrow && index === len - 1) || index !== len - 1 ? 'custom-right-arrow' : ''}`}
            >
              {item.url ? (
                <a href={item.url} className={`text-[#54657D] hover:!text-[#0093E6]`} data-spm={item.spm}>
                  <div className={'flex h-[22px] items-center justify-center'}>{item.name}</div>
                </a>
              ) : (
                <span
                  className={`flex h-[22px] cursor-default items-center justify-center ${len - 1 === index ? 'text-[#999999]' : 'text-[#54657D]'}`}
                >
                  {item.name}
                </span>
              )}
            </StyledLi>
          );
        })}
      </ol>
    </nav>
  );
};

export default memo(Nav);
